import { BaseComponent } from 'src/scripts/components/base-component'
import { BodyElement } from 'src/scripts/components/body-element/body-element'
import { isMobile } from 'src/scripts/utils/check-media'
import { $el } from 'src/scripts/utils/utils'

const OVERLAY_SELECTOR = 'body-element'

export class CloseCursor extends BaseComponent {
  overlaySelector: string
  isInited: boolean
  overlay: BodyElement

  constructor() {
    super()

    this.isInited = false
    this.overlay = $el(OVERLAY_SELECTOR)
  }

  handleMouseMove = (event: MouseEvent): void => {
    this.toggleVisibility(event)
  }

  toggleVisibility = (event: MouseEvent): void => {
    const target = event.target as HTMLElement
    const isOnOverlay = this.checkIsOnOverlay(target)

    if (isOnOverlay) {
      this.setVisible(event)
    } else {
      this.setHidden()
    }
  }

  setVisible(event: MouseEvent): void {
    this.setAttribute('visible', '')

    const { clientY: top, clientX: left } = event

    this.style.transform = `translate(calc(-50% + ${left}px), calc(-50% + ${top}px))`
  }

  setHidden(): void {
    this.removeAttribute('visible')
  }

  setInitialVisibility = (clickEvent: MouseEvent): void => {
    const { clientY, clientX } = clickEvent
    const target = document.elementFromPoint(clientX, clientY)
    const isOnOverlay = this.checkIsOnOverlay(target)

    if (isOnOverlay) {
      this.setVisible(clickEvent)
    }
  }

  toggle(clickEvent?: MouseEvent): void {
    if (!isMobile() && this.overlay.isVisible) {
      this.isInited ? this.deInit() : this.init(clickEvent)
    }
  }

  init = (clickEvent: MouseEvent): void => {
    window.addEventListener('mousemove', this.handleMouseMove)

    if (clickEvent?.clientX) {
      this.setInitialVisibility(clickEvent)
    }

    this.isInited = true
  }

  deInit(): void {
    window.removeEventListener('mousemove', this.handleMouseMove)
    this.setHidden()

    this.isInited = false
  }

  checkIsOnOverlay(target: EventTarget | null): boolean {
    return target === this.overlay
  }
}
